import { render, staticRenderFns } from "./upload-avatar.vue?vue&type=template&id=668fa03c&scoped=true&"
import script from "./upload-avatar.vue?vue&type=script&lang=js&"
export * from "./upload-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668fa03c",
  null
  
)

export default component.exports